import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/observability/page.tsx");
